var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      attrs: {
        label: _vm.label,
        description: _vm.description,
        state: _vm.error ? false : null,
        "invalid-feedback": _vm.hint
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closePicker,
              expression: "closePicker"
            }
          ],
          ref: "parent",
          staticClass: "date-time-picker",
          attrs: { id: _vm.$attrs.id + "-wrapper" }
        },
        [
          _vm.hasInput
            ? _c(
                "CustomInput",
                _vm._b(
                  {
                    ref: "custom-input",
                    attrs: {
                      id: _vm.$attrs.id + "-input",
                      placeholder: _vm.$attrs.placeholder,
                      dark: _vm.dark,
                      hint: _vm.hint,
                      disabled: !!_vm.$attrs.disabled,
                      "error-hint": _vm.error,
                      "is-focus": _vm.hasPickerOpen,
                      color: _vm.color,
                      label: _vm.label,
                      "no-label": _vm.noLabel,
                      "input-size": _vm.inputSize,
                      "no-clear-button": _vm.noClearButton
                    },
                    on: {
                      focus: function($event) {
                        return _vm.toggleDatePicker(true)
                      },
                      clear: function($event) {
                        return _vm.$emit("input", null)
                      }
                    },
                    model: {
                      value: _vm.dateFormatted,
                      callback: function($$v) {
                        _vm.dateFormatted = $$v
                      },
                      expression: "dateFormatted"
                    }
                  },
                  "CustomInput",
                  _vm.$attrs,
                  false
                )
              )
            : _vm._t("default"),
          _vm._v(" "),
          _vm.hasPickerOpen && _vm.overlay
            ? _c("div", {
                staticClass: "time-picker-overlay",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.closePicker($event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isDisabled
            ? _c("PickersContainer", {
                ref: "agenda",
                attrs: {
                  id: _vm.$attrs.id + "-picker-container",
                  visible: _vm.hasPickerOpen,
                  position: _vm.pickerPosition,
                  inline: _vm.inline,
                  color: _vm.color,
                  "button-color": _vm.buttonColor,
                  dark: _vm.dark,
                  "no-header": _vm.noHeader,
                  "only-time": _vm.onlyTime,
                  "only-date": _vm.hasOnlyDate,
                  "minute-interval": _vm.minuteInterval,
                  locale: _vm.locale,
                  "min-date": _vm.minDate,
                  "max-date": _vm.maxDate,
                  format: _vm.format,
                  "no-weekends-days": _vm.noWeekendsDays,
                  "disabled-weekly": _vm.disabledWeekly,
                  "has-button-validate": _vm.hasButtonValidate,
                  "has-no-button": _vm.hasNoButton,
                  range: _vm.range,
                  "disabled-dates": _vm.disabledDates,
                  "disabled-hours": _vm.disabledHours,
                  "enabled-dates": _vm.enabledDates,
                  "no-shortcuts": _vm.noShortcuts,
                  "button-now-translation": _vm.buttonNowTranslation,
                  "no-button-now": _vm.noButtonNow,
                  "first-day-of-week": _vm.firstDayOfWeek,
                  "custom-shortcuts": _vm.customShortcuts,
                  "no-keyboard": _vm.noKeyboard,
                  right: _vm.right,
                  behaviour: _vm._behaviour
                },
                on: { validate: _vm.validate, close: _vm.closePicker },
                model: {
                  value: _vm.dateTime,
                  callback: function($$v) {
                    _vm.dateTime = $$v
                  },
                  expression: "dateTime"
                }
              })
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }